export const authService = {
    loginWithGoogle: async () => {
      try {
        console.log("Google Sign-In...");
        // Aquí puedes implementar la autenticación con Google usando Firebase o Expo AuthSession.
      } catch (error) {
        console.error("Error al iniciar sesión con Google", error);
      }
    },
  };

export interface LoginPayload {
  username: string;
  password: string;
  grant_type: string;
  client_id: string;
  scope: string;
}

export interface LoginResponse {
  access_token: string;
  [key: string]: any;
}

export const loginWithBackend = async (payload: LoginPayload): Promise<LoginResponse> => {
  const API_BACKEND = process.env.GAIA_BACKEND!;
  
  const response = await fetch(`${API_BACKEND}oauth/token/v2`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error?.message || "Login failed");
  }

  return response.json();
};